import { tss } from 'tss-react/mui';

export const usePageHeroStyles = tss.withName('PageHero').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        padding: theme.spacing(22, '6%', 10),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(18, '6%', 8),
        },
    },
    inner: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(2.5),
    },
    subtitle: {
        color: theme.palette.fog,
        maxWidth: 560,
        marginTop: theme.spacing(3),
    },
}));
